// extracted by mini-css-extract-plugin
module.exports = {"message":"widget-space--message--3cuHa","title":"widget-space--title--3zU6v"};